import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Stack,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  alertTemplateToggle: boolean;
  alertTemplateOnClose: () => void;
  features: string[];
};

const KeyFeatureDialog = ({
  alertTemplateToggle,
  alertTemplateOnClose,
  features,
}: Props) => {
  return (
    <Dialog
      open={alertTemplateToggle}
      onClose={alertTemplateOnClose}
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='h6' fontWeight={700}>
          Highlighted Features
        </Typography>
        <Button
          variant='outlined'
          sx={{
            minWidth: 'auto',
            color: 'rgba(75, 75, 75, 1)',
            height: 42,
            width: 42,
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'transparent',
              color: 'rgba(75, 75, 75, 1)',
            },
          }}
          onClick={alertTemplateOnClose}
        >
          <CloseIcon sx={{ fontSize: '1.8em' }} />
        </Button>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={1}>
          {features.map((feature, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                bgcolor: 'rgba(0, 0, 0, 0.04)',
                px: 2,
                py: 1,
                borderRadius: 1,
                boxShadow: 1,
                transition: 'background-color 0.3s',
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.08)',
                },
              }}
            >
              {/* <MdMotionPhotosOn
                size={20}
                color='primary.light'
                aria-hidden='true'
              /> */}
              <Box
                component={'img'}
                src={
                  'https://miles-cdn.qrbuddy.ai/static/autospotlight/ic_motion_photos_on.svg'
                }
                sx={{
                  height: 16,
                }}
              />
              <Typography fontSize={14} color='text.primary'>
                {feature}
              </Typography>
            </Box>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default KeyFeatureDialog;
